import * as React from "react";
function LabelComponent({text}) {
  return <label className="text-gray text-sm">{text}</label>;
}

export default LabelComponent;
